import { render, staticRenderFns } from "./TransactionDetailView.vue?vue&type=template&id=562e8440&scoped=true&"
import script from "./TransactionDetailView.vue?vue&type=script&lang=ts&"
export * from "./TransactionDetailView.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionDetailView.vue?vue&type=style&index=0&id=562e8440&lang=scss&scoped=true&"
import style1 from "./TransactionDetailView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562e8440",
  null
  
)

export default component.exports